export default function safeTemplateString(value, coma = false) {
  if (!value) {
    return '';
  }
  return coma ? `${value}, ` : value;
}
